import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProductAuxConnector } from './product-aux.connector';
import { ProductsPricesRequest, ProductsPricesRequestConfig } from '../../../../core/models/product.model';
import { initialStatus } from '../../../../core/models/request-status.model';
import { SimpleEntry } from '../../../../core/models/orderEntry.model';

@Injectable({
  providedIn: 'root',
})
export class ProductAuxService {
  productsPrices$ = new BehaviorSubject<ProductsPricesRequest>(initialStatus);
  constructor(private productAuxConnector: ProductAuxConnector) {}

  getProductsPrices(config: ProductsPricesRequestConfig): Observable<ProductsPricesRequest> {
    return this.productAuxConnector.getProductsPrices(config);
  }

  addToCartInLot(entries: SimpleEntry[]) {
    return this.productAuxConnector.addToCartInLot(entries);
  }

  getProductsByIDS(productIds: string[]) {
    return this.productAuxConnector.getProductsByIDS(productIds);
  }
}
